import { debounce } from "lodash";
import moment from "moment";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialActions from "../../../actions/trial";
import * as TrialGroupActions from "../../../actions/trialGroup";
import * as TrialInstitutionActions from "../../../actions/trialInstitution";
import { NotificationAlert } from "../../../components/common/index";
import { DatePickerFormInputFabric, TextAreaFormInput } from "../../../components/form";
import { CheckboxFormInput, SelectFormInput, TextFormInput } from "../../../components/form/index";
import Link from "../../../components/routing/Link";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { TrialInstitutionCreateBreadcrumbs, TrialInstitutionDetailsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { findLookup, findLookupValue, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { TrialInstitutionSubMenu } from "../../../helpers/subMenuHelper";
import { useNavigate } from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { TrialInstitutionLayout } from "../../index";

import "./TrialInstitutionPage.scss";

interface TrialInstitutionPageProps {
    form: Dtos.TrialInstitution & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    trialInstitution: Dtos.TrialInstitution;
    trialGroups: Dtos.TrialGroup[];
    trial: Dtos.Trial;
    lookups: Dtos.Lookup[];
    loadingTrialInstitution: boolean;
    loadTrialInstitutionSuccess: boolean;
    loadTrialInstitutionFailure: boolean;
    loadTrialInstitutionErrorCode: string;
    savingTrialInstitution: boolean;
    saveTrialInstitutionSuccess: boolean;
    saveTrialInstitutionFailure: boolean;
    creatingTrialInstitution: boolean;
    createTrialInstitutionSuccess: boolean;
    createTrialInstitutionFailure: boolean;
    validatingTrialInstitution: boolean;
    loadingTrialGroups: boolean;
    loadTrialGroupsSuccess: boolean;
    loadTrialGroupsFailure: boolean;
    loadTrialGroupsErrorCode: string;
    loadingTrial: boolean;
    loadTrialSuccess: boolean;
    loadTrialFailure: boolean;
    loadTrialErrorCode: string;
    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    clearTrialInstitution: TrialInstitutionActions.ITrialInstitutionClearActionCreator;
    loadTrialInstitution: TrialInstitutionActions.ITrialInstitutionLoadByIdActionCreator;
    saveTrialInstitution: TrialInstitutionActions.ITrialInstitutionSaveActionCreator;
    createTrialInstitution: TrialInstitutionActions.ITrialInstitutionCreateActionCreator;
    validateTrialInstitution: TrialInstitutionActions.ITrialInstitutionValidateActionCreator;
    clearTrialGroups: TrialGroupActions.ITrialGroupClearActionCreator;
    loadTrialGroups: TrialGroupActions.ITrialGroupsLoadByTrialIdActionCreator;
    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.trialInstitution";

const TrialInstitutionPage: FC<TrialInstitutionPageProps> = ({
    form,
    formState,
    formProperties,
    trialInstitution,
    trialGroups,
    trial,
    lookups,
    loadingTrialInstitution,
    //loadTrialInstitutionSuccess,
    loadTrialInstitutionFailure,
    loadTrialInstitutionErrorCode,
    savingTrialInstitution,
    saveTrialInstitutionSuccess,
    saveTrialInstitutionFailure,
    creatingTrialInstitution,
    //createTrialInstitutionSuccess,
    //createTrialInstitutionFailure,
    validatingTrialInstitution,
    loadingTrialGroups,
    //loadTrialGroupsSuccess,
    loadTrialGroupsFailure,
    loadTrialGroupsErrorCode,
    loadingTrial,
    //loadTrialSuccess,
    loadTrialFailure,
    loadTrialErrorCode,
    validationFailures,
    permissions,
    clearTrialInstitution,
    loadTrialInstitution,
    saveTrialInstitution,
    createTrialInstitution,
    validateTrialInstitution,
    clearTrialGroups,
    loadTrialGroups,
    clearTrial,
    loadTrial,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { trialId } = useParams<{ trialId: string }>();
    const { trialInstitutionId } = useParams<{ trialInstitutionId: string }>();
    const trialIdNumber = parseInt(trialId, 10);
    const trialInstitutionIdNumber = parseInt(trialInstitutionId, 10);

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [formInitalised, setFormInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();

    const loadReduxForm = () => {
        let extraData: Dtos.TrialInstitution = {} as Dtos.TrialInstitution;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialInstitution }, extraData)
        );
    };



    // Load/Create Trial Institution, Load trial & groups
    useEffect(() => {
        if (trialInstitutionIdNumber && trialIdNumber && !trialInstitution && !loadingTrialInstitution) {
            setBreadcrumbs(TrialInstitutionDetailsBreadcrumbs(trialIdNumber, trialInstitutionIdNumber));

            loadTrialInstitution(trialInstitutionIdNumber);
        }
        else if (!trialInstitutionIdNumber && trialIdNumber && !trialInstitution && !creatingTrialInstitution) {
            setDrawerItems([]);
            setBreadcrumbs(TrialInstitutionCreateBreadcrumbs(trialIdNumber));

            createTrialInstitution(trialIdNumber);
        }
        else if (trialInstitution && !formInitalised) {
            loadReduxForm();
            setFormInitalised(true);
        }

        if (trialIdNumber && !trial && !loadingTrial) {
            loadTrial(trialIdNumber);
            loadTrialGroups(trialIdNumber);
        }
    }, [
        trialInstitutionIdNumber,
        trialIdNumber,
        trialInstitution,
        loadingTrialInstitution,
        setBreadcrumbs,
        TrialInstitutionDetailsBreadcrumbs,
        loadTrialInstitution,
        creatingTrialInstitution,
        setDrawerItems,
        TrialInstitutionCreateBreadcrumbs,
        createTrialInstitution,
        formInitalised,
        loadReduxForm,
        setFormInitalised,
        trial,
        loadingTrial,
        loadTrial
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadTrialInstitutionFailure) {
            navigate(`/error/${loadTrialInstitutionErrorCode}`);
        }
        if (loadTrialFailure) {
            navigate(`/error/${loadTrialErrorCode}`);
        }
        if (loadTrialGroupsFailure) {
            navigate(`/error/${loadTrialGroupsErrorCode}`);
        }
    }, [
        loadTrialInstitutionFailure,
        loadTrialFailure,
        loadTrialInstitutionErrorCode,
        loadTrialErrorCode,
        loadTrialGroupsFailure,
        loadTrialGroupsErrorCode,
        navigate,
    ]);

    // Update breadcrumbs & drawer items
    useEffect(() => {
        if (trialIdNumber && trialInstitutionIdNumber && trialInstitution && trial && permissions) {
            setDrawerItems(TrialInstitutionSubMenu(trialInstitution, permissions));
            setBreadcrumbs(
                TrialInstitutionDetailsBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trial?.displayName,
                    trialInstitution?.institution?.name
                )
            );
        }
        else if (!trialInstitutionIdNumber && trialIdNumber && trial) {
            setDrawerItems([]);
            setBreadcrumbs(TrialInstitutionCreateBreadcrumbs(trialIdNumber, trial?.displayName));
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitution,
        trial,
        permissions,
        setDrawerItems,
        TrialInstitutionSubMenu,
        setBreadcrumbs,
        TrialInstitutionDetailsBreadcrumbs,
        TrialInstitutionCreateBreadcrumbs
    ]);

    // Reload trial personnel after saving
    useEffect(() => {
        if (!savingTrialInstitution && saveTrialInstitutionSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Trial institution saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(`/trials/${trialIdNumber}/institutions`);
            } else if (!trialInstitutionIdNumber) {
                navigate(`/trials/${trialIdNumber}/trialinstitution/${trialInstitution?.id}/details`);
                clearTrialInstitution();
                clearTrial();
                clearTrialGroups();
            }
        }
    }, [
        savingTrialInstitution,
        saveTrialInstitutionSuccess
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingTrialInstitution && saveTrialInstitutionFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingTrialInstitution, saveTrialInstitutionFailure]);

     // Cleanup effect to clear the trial institution on component unmount
    useEffect(() => {
        return () => {
            clearTrial();
            clearTrialInstitution();
            clearTrialGroups();
            resetForm(reduxFormName);
        };
    }, [clearTrial, clearTrialInstitution, clearTrialGroups, resetForm, reduxFormName]);

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.TrialInstitution = {} as Dtos.TrialInstitution;

            await saveTrialInstitution(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    const handleOnSubmitFailed = (_data: Dtos.TrialInstitution) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const onCancel = () => {
        navigate(`/trials/${trialIdNumber}/institutions`);
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.TrialInstitution = {} as Dtos.TrialInstitution;

            if (form && hasBeenSubmitted && !validatingTrialInstitution) {
                await validateTrialInstitution(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const getImportStatus = (importStatusId: number) => {
        switch (importStatusId) {
            case 0:
                return (
                    <span className="import-status">
                        Imported from trial database.
                    </span>
                );
            case 1:
                return (
                    <span className="import-status">
                        No patients randomised yet.
                    </span>
                );
            case 2:
                return (
                    <span className="import-status-red">
                        No institution code set.
                    </span>
                );
            case 3:
                return (
                    <span className="import-status-red">
                        Error importing date.
                    </span>
                );
        }
    }

    const renderContent = useMemo(() => {
        const trialGroupIds = trialGroups?.map((y) => y.groupId) || [];
        const lookupOptions = findLookup("trialInstitution", "GroupId", lookups);
        const filteredOptions = generateOptionsFromLookup(lookupOptions, form?.groupId)?.filter((option) => trialGroupIds.includes(option.value));

        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.TrialInstitutionUpdate,
                Dtos.Permission.TrialInstitutionCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingTrialInstitution ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12 pb-4">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            institutionId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled || !isNaN(trialInstitutionIdNumber),
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitution",
                                                                "institutionId",
                                                                lookups
                                                            ),
                                                            form.institutionId
                                                        )?.filter((option) => !trialInstitution?.institutionIds?.includes(option.value)),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-2 col-xl-12",
                                                fieldClassName: "col-xxl-10 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            trialInstitutionStatusId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitution",
                                                                "trialInstitutionStatusId",
                                                                lookups
                                                            ),
                                                            form.trialInstitutionStatusId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-7 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            dateWithdrawn: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-8 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            {trial?.substudy?.protocolID != null ? (
                                <div className="form-row py-2 px-4">
                                    <div className="col-12">
                                        {renderFormControls(
                                            form,
                                            "trialInstitution",
                                            {
                                                substudyStatusId: {
                                                    type: RegistrationComponent.RegistrationControl,
                                                    inputType: TextFormInput,
                                                    inputDisabled: true,
                                                    groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                    labelClassName: "col-form-label col-xxl-2 col-xl-12",
                                                    fieldClassName: "col-xxl-10 col-xl-12 generic-form-field",
                                                    inputProps: {
                                                        value:
                                                            trial?.substudy?.protocolID +
                                                            " : " +
                                                            findLookupValue(
                                                                "TrialInstitution",
                                                                "trialInstitutionStatusId",
                                                                trial?.substudy?.trialStatusId,
                                                                lookups
                                                            ),
                                                    },
                                                    inputLabel: "Substudy Status",
                                                },
                                            },
                                            lookups,
                                            validationFailures,
                                            formProperties,
                                            changeForm
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}

                            <div className="form-row py-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            institutionCodeId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: true,
                                                inputProps: {
                                                    value: form?.institutionCode?.codeValue ?? null,
                                                },
                                                inputLabel: "Institution Code",
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-7 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            departmentId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitution",
                                                                "departmentId",
                                                                lookups
                                                            ),
                                                            form?.departmentId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-8 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            groupId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options: filteredOptions,
                                                    clearable: true,
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-2 col-xl-12",
                                                fieldClassName: "col-xxl-10 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            recruitmentGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <div className="form-row d-flex">
                            <div className="col-xxl-6 col-xl-12 d-flex flex-column">
                                <h1>Recruitment</h1>
                                <div className="card card-shadow h-100">
                                    <div className="form-row py-2 px-4">
                                        <div className="col-md-12">
                                            {renderFormControls(
                                                form,
                                                "institution",
                                                {
                                                    disableRecruitment: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: CheckboxFormInput,
                                                        inputDisabled: formDisabled,
                                                        inputProps: {
                                                            label: "Disable Recruitment for this Institution",
                                                        },
                                                        inputLabel: " ",
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-0",
                                                        fieldClassName: "col-sm-12 generic-form-field",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row py-2 px-4">
                                        <div className="col-md-12">
                                            {renderFormControls(
                                                form,
                                                "trialInstitution",
                                                {
                                                    dateActivated: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: DatePickerFormInputFabric,
                                                        inputDisabled: formDisabled,
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-4",
                                                        fieldClassName: "col-sm-8 generic-form-field",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row py-2 px-4">
                                        <div className="col-md-12">
                                            {renderFormControls(
                                                form,
                                                "trialInstitution",
                                                {
                                                    firstPatient: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: DatePickerFormInputFabric,
                                                        inputDisabled: formDisabled,
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-4",
                                                        fieldClassName: "col-sm-8 generic-form-field",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row py-2 px-4">
                                        <div className="col-md-12 d-flex align-items-center justify-content-end">
                                            {getImportStatus(form?.importStatusId)}
                                        </div>
                                    </div>
                                    {trial?.dateAccrualComplete !== undefined ? (
                                        <div className="form-row pt-2 pb-4 px-4">
                                            <div className="col-md-12 d-flex align-items-center justify-content-end">
                                                <span className="date-accrual-status">
                                                    Note: Trial Accrual Complete&nbsp;
                                                    {moment(trial.dateAccrualComplete).format("DD/MM/YYYY")}
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-12 d-flex flex-column">
                                <h1>EOI</h1>
                                <div
                                    className="card card-shadow h-100"
                                    style={{ zIndex: 1 }}
                                >
                                    <div className="form-row pt-4 pb-2 px-4">
                                        <div className="col-12">
                                            {renderFormControls(
                                                form,
                                                "trialInstitution",
                                                {
                                                    initationMeetingDate: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: DatePickerFormInputFabric,
                                                        inputDisabled: formDisabled,
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-lg-4 col-md-12",
                                                        fieldClassName: "col-lg-8 col-md-12 generic-form-field",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row py-2 px-4">
                                        <div className="col-lg-4 col-md-12 d-flex align-items-center">
                                            <span>
                                                Estimated Accrual (per year)
                                            </span>
                                        </div>
                                        <div className="col-lg-8 col-md-12">
                                            {renderFormControls(
                                                form,
                                                "trialInstitution",
                                                {
                                                    minAccrual: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: TextFormInput,
                                                        inputDisabled: formDisabled,
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-2",
                                                        fieldClassName: "col-sm-10 generic-form-field",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row pt-2 pb-4 px-4">
                                        <div className="offset-lg-4 col-lg-8 offset-md-0 col-md-12">
                                            {renderFormControls(
                                                form,
                                                "trialInstitution",
                                                {
                                                    maxAccrual: {
                                                        type: RegistrationComponent.RegistrationControl,
                                                        inputType: TextFormInput,
                                                        inputDisabled: formDisabled,
                                                        groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                        labelClassName: "col-form-label col-sm-2",
                                                        fieldClassName: "col-sm-10 generic-form-field",
                                                    },
                                                },
                                                lookups,
                                                validationFailures,
                                                formProperties,
                                                changeForm
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            institutionClosureGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Institution Closure</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            closureDate: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-md-12 col-lg-2",
                                                fieldClassName: "col-md-12 col-lg-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            institutionClosureReasonId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitution",
                                                                "institutionClosureReasonId",
                                                                lookups
                                                            ),
                                                            form.institutionClosureReasonId
                                                        ),
                                                    clearable: true,
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-md-12 col-lg-2",
                                                fieldClassName: "col-md-12 col-lg-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            ethicsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Ethics</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            submissionProcessId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitution",
                                                                "submissionProcessId",
                                                                lookups
                                                            ),
                                                            form.submissionProcessId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-7 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            siteRoleId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitution",
                                                                "siteRoleId",
                                                                lookups
                                                            ),
                                                            form.siteRoleId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-8 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            hrecId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitution",
                                                                "hrecId",
                                                                lookups
                                                            ),
                                                            form.hrecId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-2 col-xl-12",
                                                fieldClassName: "col-xxl-10 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pb-4 pt-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            ethicsApproval: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-7 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            governanceAuthorisation: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-xxl-4 col-xl-12",
                                                fieldClassName: "col-xxl-8 col-xl-12 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            commentGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Comments</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-3 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitution",
                                        {
                                            comments: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-0",
                                                fieldClassName: "col-sm-12 generic-form-field",
                                                inputLabel: " ",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Details</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        {AuthenticationHelper.hasPermission(
                            permissions,
                            Dtos.Permission.TrialInstitutionView
                        ) && trialInstitutionIdNumber && trialInstitution ? (
                            <Link
                                className={"btn btn-primary"}
                                url={`/institutions/${trialInstitution?.institutionId}/details`}
                                target="_blank"
                            >
                                {`Primary  `}
                                <FontAwesomeIcon icon={FontAwesomeIcons.Duotone.ARROWUPRIGHTFROMSQUARE} />
                            </Link>
                        ) : null}
                    </div>
                </div>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => handleOnSubmit(val)}
                    onSubmitFailed={(val) => handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "trialInstitution",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(reduxFormName + ".saveAndReturn", false);
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(reduxFormName + ".saveAndReturn", true);
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={onCancel}
                            className="btn btn-primary mr-2"
                        >
                            Cancel
                        </button>
                    </div>
                </Form>
            </>
        );
    }, [
        trial,
        findLookup,
        lookups,
        generateOptionsFromLookup,
        form,
        permissions,
        savingTrialInstitution,
        formState,
        trialInstitutionIdNumber,
        renderFormControls,
        validationFailures,
        formProperties,
        changeForm,
        trialInstitution,
        reduxFormName,
        handleOnSubmit,
        handleOnSubmitFailed,
        onCancel,
        trialGroups
    ]);

    return (
        <TrialInstitutionLayout
            loading={
                loadingTrialInstitution || 
                creatingTrialInstitution || 
                loadingTrial || 
                loadingTrialGroups
            }
            permission={Dtos.Permission.TrialInstitutionView}
        >
            { renderContent }
        </TrialInstitutionLayout>
    )
};

const mapStateToProps = (state: ITmdState): Partial<TrialInstitutionPageProps> => {
    let trialInstitution: Dtos.TrialInstitution | undefined = !(state.trialInstitution.formData instanceof Array)
        ? state.trialInstitution.formData
        : undefined;
    let trialGroups: Dtos.TrialGroup[] | undefined = (state.trialGroup.formData instanceof Array)
        ? state.trialGroup.formData
        : undefined;
    let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array)
        ? state.trials.formData
        : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {
        trialInstitution: trialInstitution!,
        trialGroups: trialGroups!,
        trial: trial!,
        loadingTrialInstitution: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Pending,
        loadTrialInstitutionSuccess: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Success,
        loadTrialInstitutionFailure: state.trialInstitution.loadState && state.trialInstitution.loadState.status == RequestState.Failure,
        loadTrialInstitutionErrorCode: state.trialInstitution.loadState.errorCode,
        savingTrialInstitution: state.trialInstitution.saveState && state.trialInstitution.saveState.status == RequestState.Pending,
        saveTrialInstitutionSuccess: state.trialInstitution.saveState && state.trialInstitution.saveState.status == RequestState.Success,
        saveTrialInstitutionFailure: state.trialInstitution.saveState && state.trialInstitution.saveState.status == RequestState.Failure,
        creatingTrialInstitution: state.trialInstitution.createState && state.trialInstitution.createState.status == RequestState.Pending,
        createTrialInstitutionSuccess: state.trialInstitution.createState && state.trialInstitution.createState.status == RequestState.Success,
        createTrialInstitutionFailure: state.trialInstitution.createState && state.trialInstitution.createState.status == RequestState.Failure,
        validatingTrialInstitution: state.trialInstitution.validateState && state.trialInstitution.validateState.status == RequestState.Pending,
        loadingTrialGroups: state.trialGroup.loadState && state.trialGroup.loadState.status == RequestState.Pending,
        loadTrialGroupsSuccess: state.trialGroup.loadState && state.trialGroup.loadState.status == RequestState.Success,
        loadTrialGroupsFailure: state.trialGroup.loadState && state.trialGroup.loadState.status == RequestState.Failure,
        loadTrialGroupsErrorCode: state.trialGroup.loadState.errorCode,
        loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
        loadTrialSuccess: state.trials.loadState && state.trials.loadState.status == RequestState.Success,
        loadTrialFailure: state.trials.loadState && state.trials.loadState.status == RequestState.Failure,
        loadTrialErrorCode: state.trials.loadState.errorCode,
        permissions: permissions,
        lookups: state.trialInstitution.lookups,
        form: state.reduxForms.trialInstitution,
        formState: state.trialInstitution.formState,
        formProperties: state.trialInstitution.formProperties,
        validationFailures: trialInstitution
            ? state.trialInstitution.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (dispatch): Partial<TrialInstitutionPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadTrialInstitution: bindActionCreators(TrialInstitutionActions.LoadTrialInstitutionById, dispatch),
        clearTrialInstitution: bindActionCreators(TrialInstitutionActions.Clear, dispatch),
        loadTrialGroups: bindActionCreators(TrialGroupActions.LoadTrialGroupsByTrialId, dispatch),
        clearTrialGroups: bindActionCreators(TrialGroupActions.Clear, dispatch),
        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch),
        saveTrialInstitution: bindActionCreators(TrialInstitutionActions.SaveTrialInstitution, dispatch),
        createTrialInstitution: bindActionCreators(TrialInstitutionActions.CreateTrialInstitution, dispatch),
        validateTrialInstitution: bindActionCreators(TrialInstitutionActions.ValidateTrialInstitution, dispatch),
        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrialInstitutionPage);